module.exports = __webpack_public_path__ + "f63eb439cf59bb1c6ffd705715158b1c.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/imageslider/slider-01.jpg
 ** module id = 23
 ** module chunks = 0
 **/